export default "__VITE_ASSET__B7Nsxe_h__"